<template>
  <dg-field-container :field_mark="field_mark" :field_span="field_span" :label_span="label_span"
                      style="min-height: 200px">
    <template v-slot:label>
      <dg-label-field :label="label" :translate="translateLabel" v-if='label'></dg-label-field>
    </template>
    <template v-slot:field>
      <el-upload
          :action="autoUploadPath" :auto-upload="autoUpload"
          :before-upload="beforeAvatarUpload"
          :on-change="onChange"
          :on-success="handleAvatarSuccess"
          :show-file-list="false"
          class="avatar-uploader">
        <div class="filename">{{ fileName }}</div>
        <img :src="previewImage" class="avatar" v-if="previewImage">
        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
      </el-upload>
      <el-button size="mini" icon="el-icon-download" v-if="downloadEvent && imageUrl" @click="handleDownload(file)">save</el-button>
      <el-button size="mini" icon="el-icon-view" v-if="viewEvent && imageUrl" @click="handlePictureCardPreview(file)">view</el-button>
      <slot name="field_note"></slot>
      <div class="error-field-validate-message" v-if="validateMessage">
        {{ validateMessage }}
      </div>
    </template>
  </dg-field-container>
</template>

<script>
/*   unused Feature: autoload */
import inputField from '../mixins/inputField';

export default {
  mixins: [inputField],
  props: {
    autoUpload: {
      required: false,
      default: false
    },
    autoUploadPath: {
      required: false,
      default: ''
    },
    label: {
      required: true,
      type: String
    },
    allowedExt: {
      required: true,
      type: Array
    },
    fileSizeLimit: {
      required: false,
      default: 2 // in MB
    },
    downloadEvent: {
      required: false,
      default: false
    },
    viewEvent: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      imageUrl: '',
      binding: 'image',
      fileName: '',
      readyForDownload: false,
      previewImage: '',
      extAndIcons: {
        'pdf': 'file',
        'xls': 'file',
        'xlsx': 'file',
        'mp3': 'file',
        'mp4': 'file',
      }
    };
  },
  methods: {
    prepareForEvent() {
      return {
        url: this.imageUrl,
        name: 'file',
        extension: this.getExtensionFromUrl(this.imageUrl),
        isImage: this.isExtenionForImage(this.getExtensionFromUrl(this.imageUrl))
      }
    },
    handleDownload(file) {
      this.downloadEvent(this.prepareForEvent())
    },
    handlePictureCardPreview() {
      this.viewEvent(this.prepareForEvent())
    },
    setImageUrl (url) {
      this.imageUrl = url
      let ext = this.getExtensionFromUrl(url)
      if (this.isExtenionForImage(ext)) {
        this.previewImage = url
      } else {
        this.previewImage = this.getThumbnail(ext)
      }
    },
    submitUpload() {
      this.$refs.avatar.submit();
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    onChange(file) {
      if (this.beforeAvatarUpload(file.raw)) {
        this.fileName = file.name;
        this.previewImage = this.getFileThumbnail(file);
        this.field_value = file.raw;
        W_LOGGER('this.field_value', this.field_value);
        this.updateValue();
      }
    },
    getThumbnail (ext) {
      if (this.extAndIcons.hasOwnProperty(ext)) return '/img/files/' + this.extAndIcons[ext] + '.png'
      return '/img/files/file.png'
    },
    getFileThumbnail(file) {
      if (this.fileIsImage(file.raw)) {
        return URL.createObjectURL(file.raw);
      }
      return this.getThumbnail(file.name.split('.')[1]);
    },
    getExtensionFromUrl (url) {
      return url.substring(url.lastIndexOf('/') + 1).split('.')[1];
    },
    isExtenionForImage (ext) {
      return ['jpeg', 'jpg', 'png', 'svg'].indexOf(ext) !== -1;
    },
    fileIsImage(file) {
      return ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml'].indexOf(file.type) !== -1;
    },
    beforeAvatarUpload(file) {
      if (this.autoUpload && this.autoUploadPath == '') {
        this.$message.error('No Auto Upload Path Defined');
        return false;
      }
      let fileExt = file.name.split('.');
      if (fileExt.length > 1) {
        fileExt = fileExt[fileExt.length - 1];
      } else {
        fileExt = ''
      }
      let allowedExt = this.allowedExt;
      const validExt = allowedExt.indexOf(fileExt) !== -1;
      const maxMBSize = file.size / 1024 / 1024 <= this.fileSizeLimit; // 2MB max file size

      if (!validExt) {
        this.$message.error('file must be from these formats: ' + allowedExt);
      }
      if (!maxMBSize) {
        this.$message.error(this.$ml.get('file_cant_exceed_size') + this.fileSizeLimit + 'MB');
      }
      return validExt && maxMBSize;
    }
  }
}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
